import styled from "styled-components";
export interface CodeBtnProps {
	imgUrl: string;
}
export const CodeBtn = styled.div`
	background-image: ${(props: CodeBtnProps) => `url(${props.imgUrl})`};
	border: none;
	background-size: cover;
	cursor: pointer;
	:focus {
		outline: none;
	}
`;
export const CouponContainer = styled.section`
	width: 100%;
	height: fit-content;
`;

export interface InnerBoxProps {
	columnSize: number;
	rows: number;
}
export const InnerBox = styled.div`
	margin: 0 auto;
	width: 1200px;
	display: grid;
	grid-row-gap: 20px;
	grid-template-rows: ${(props: InnerBoxProps) => `repeat(${props.rows},175px)`};
	${(props: InnerBoxProps) => {
		switch (props.columnSize) {
			case 2:
				return `
				grid-template-columns: 590px 590px;
				grid-column-gap: 20px;
				`;
			case 3:
				return `
				grid-template-columns: repeat(3, 386px);
				grid-column-gap: 21px;
					`;
			default:
				return null;
		}
	}};
`;
